<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
      name: 'app',
      data(){
          return{

          }
      },
      mounted() {
       // 	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

        // if(flag){
        //   window.open("http://wxee.zwdit.com/#/","_self");
        // }

      }
  }
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
</style>
